const allSelectors = {};
const allRules = {};
const insertedTransforms = {};
const getAllSelectors = () => allSelectors;
const getAllRules = () => Object.values(allRules);
const getAllTransforms = () => insertedTransforms;
function addTransform(identifier, css, rule) {
  const s = css.indexOf("transform:");
  if (s === -1) {
    if (process.env.NODE_ENV === "development") {
      console.error(`\u274C Invalid transform, likely used deg/% improperly ${identifier}`);
    }
    return false;
  }
  const startI = s + "transform:".length;
  const endI = css.indexOf(";");
  const value = css.slice(startI, endI);
  if (!insertedTransforms[identifier]) {
    insertedTransforms[identifier] = value;
    return true;
  }
  return false;
}
const isClient = typeof document !== "undefined";
const scannedCache = /* @__PURE__ */ new WeakMap();
const totalSheetSelectors = /* @__PURE__ */ new Map();
function listenForSheetChanges() {
  if (!isClient)
    return;
  function handleNode(node, remove = false) {
    if (node instanceof HTMLStyleElement && node.sheet) {
      updateSheetStyles(node.sheet, remove);
    }
  }
  const mo = new MutationObserver((entries) => {
    for (const entry of entries) {
      entry.addedNodes.forEach((node) => handleNode(node));
      entry.removedNodes.forEach((node) => handleNode(node, true));
    }
  });
  mo.observe(document.head, {
    childList: true
  });
}
function scanAllSheets() {
  if (process.env.NODE_ENV === "test")
    return;
  if (!isClient)
    return;
  const sheets = document.styleSheets;
  if (!sheets)
    return;
  for (let i = 0; i < sheets.length; i++) {
    const sheet2 = sheets[i];
    if (!sheet2)
      continue;
    updateSheetStyles(sheet2);
  }
}
function track(id, remove = false) {
  const next = (totalSheetSelectors.get(id) || 0) + (remove ? -1 : 1);
  totalSheetSelectors.set(id, next);
  return next;
}
function updateSheetStyles(sheet2, remove = false) {
  var _a, _b;
  let rules;
  try {
    rules = sheet2.cssRules;
  } catch {
    return;
  }
  const firstSelector = (_a = getTamaguiSelector(rules[0])) == null ? void 0 : _a[0];
  if (!firstSelector) {
    return;
  }
  const lastSelector = (_b = getTamaguiSelector(rules[rules.length - 1])) == null ? void 0 : _b[0];
  const cacheKey = `${rules.length}${firstSelector}${lastSelector}`;
  const lastScanned = scannedCache.get(sheet2);
  if (!remove) {
    if (lastScanned === cacheKey) {
      return;
    }
  }
  const len = rules.length;
  for (let i = 0; i < len; i++) {
    const rule = rules[i];
    const response = getTamaguiSelector(rule);
    if (!response) {
      return;
    }
    const [identifier, cssRule] = response;
    const total = track(identifier, remove);
    if (remove) {
      if (total === 0) {
        delete allSelectors[identifier];
      }
    } else {
      if (!(identifier in allSelectors)) {
        const isTransform = identifier.startsWith("_transform");
        const shouldInsert = isTransform ? addTransform(identifier, cssRule.cssText, cssRule) : true;
        if (shouldInsert) {
          allSelectors[identifier] = cssRule.cssText;
        }
      }
    }
  }
  scannedCache.set(sheet2, cacheKey);
}
function getTamaguiSelector(rule) {
  if (rule instanceof CSSStyleRule) {
    const text = rule.selectorText;
    if (text[0] === "." && text[1] === "_") {
      return [text.slice(1), rule];
    }
    if (text.startsWith(":root") && text.includes("._")) {
      return [getIdentifierFromTamaguiSelector(text), rule];
    }
  } else if (rule instanceof CSSMediaRule) {
    if (rule.cssRules.length > 1)
      return null;
    return getTamaguiSelector(rule.cssRules[0]);
  }
  return null;
}
const getIdentifierFromTamaguiSelector = (selector) => selector.replace(/(:root)+\s+/, "").replace(/:[a-z]+$/, "").slice(1);
const sheet = isClient ? document.head.appendChild(document.createElement("style")).sheet : null;
function updateRules(identifier, rules) {
  if (allRules[identifier])
    return false;
  allRules[identifier] = rules.join(" ");
  if (identifier.startsWith("_transform")) {
    return addTransform(identifier, rules[0]);
  }
  return true;
}
function insertStyleRules(rulesToInsert) {
  if (!rulesToInsert.length)
    return;
  if (isClient && !sheet) {
    if (process.env.NODE_ENV === "development")
      throw "impossible";
    return;
  }
  for (const { identifier, rules } of rulesToInsert) {
    if (identifier in allSelectors)
      continue;
    allSelectors[identifier] = process.env.NODE_ENV === "development" ? rules.join("\n") : " ";
    updateRules(identifier, rules);
    if (sheet) {
      for (const rule of rules) {
        try {
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (err) {
          if (process.env.NODE_ENV !== "production") {
            console.groupCollapsed(
              `Error inserting rule into CSSStyleSheet: ${String(err)}`
            );
            console.log({ rule, rulesToInsert });
            console.trace();
            console.groupEnd();
          }
        }
      }
    }
  }
}
const IS_STATIC = process.env.IS_STATIC === "is_static";
function shouldInsertStyleRules(styleObject) {
  if (IS_STATIC) {
    return true;
  }
  return !(styleObject.identifier in allSelectors);
}
export {
  getAllRules,
  getAllSelectors,
  getAllTransforms,
  insertStyleRules,
  insertedTransforms,
  listenForSheetChanges,
  scanAllSheets,
  shouldInsertStyleRules,
  updateRules
};
//# sourceMappingURL=insertStyleRule.js.map
